export const API_URL = {
  Register: "accounts/api/v1/registration/",
  sendVerificationCode: "accounts/api/v1/send-verification-code/",
  verifyVerificationCode: "accounts/api/v1/verify-user/",
  Login: "accounts/api/v1/jwt/create/",
  changePassword: "accounts/api/v1/change-password/",
  resetPassword: "accounts/api/v1/forgot-password/reset/",
  requestCode: "accounts/api/v1/forgot-password/request/",
  Categories: "attachments/api/v1/category/",
  SocialMedia: "channels/api/v1/socials/",
  Tag: "attachments/api/v1/tag/",
  topTag: "attachments/api/v1/top_tags/",
  Channels: "channels/api/v1/channels/",
  Videos: "channels/api/v1/video_posts/",
  videoEdit: "channels/api/v1/video_posts_edit/",
  SpecialVideos: "channels/api/v1/special_section/",
  Messages: "channels/api/v1/notifications/",
  Profile: "accounts/api/v1/profile/",
  Subscribers: "channels/api/v1/subscriptions/",
  Comments: "channels/api/v1/comments/",
  Recommender: "channels/api/v1/recommender_videos/",
  Playlist: "channels/api/v1/play_list/",
  history: "channels/api/v1/histories/",
  ChannelAdmin: "channels/api/v1/admins/",
  UsersAllChannels: "channels/api/v1/user/",
  search: "channels/api/v1/video_posts/",
  allInfoForEachUser: "channels/api/v1/user/",
  accountUpgrade: "accounts/api/v1/request-promotion/",
  reportProblem: "support/api/v1/report_problem/",
  tutorial: "support/api/v1/help_page/",
  box: "attachments/api/v1/",
  content: "attachments/api/v1/box/", //https://vaghfnama.ir:8000/attachments/api/v1/box/14/content/
  blog: "blog/api/v1/",
  commentReport: "channels/api/v1/owner_channel_comments_report/",
  campaign: "campaigns/api/v1/",
  CampaignSubscribers: "campaigns/api/v1/subscriptions/",
  campainVideoViews: "campaigns/api/v1/increase_video_post_view/",
  Users: "accounts/api/v1/list_of_users/",
  exhibition: "exhibitions/api/v1/",
  broadcast: "channels/api/v1/notifications/send_broadcast_notification/",
  repost: "channels/api/v1/video_posts/repost/",
  permissions: "accounts/api/v1/list_of_users_permission_name/",
};

export default API_URL;
